
    import './styles.scoped.css';
    export default {
  "radio-group": "awsui_radio-group_1mabk_zha32_9",
  "horizontal-group": "awsui_horizontal-group_1mabk_zha32_40",
  "radio": "awsui_radio_1mabk_zha32_9",
  "horizontal": "awsui_horizontal_1mabk_zha32_40",
  "radio--has-description": "awsui_radio--has-description_1mabk_zha32_54"
};
  